import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { Card, Table, Button } from 'react-bootstrap';
import axios from 'axios';
 

const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

const getUserFromLocalStorage = () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    const user = JSON.parse(userStr);
    // Normalize role if needed
    if (!user.role && user.role_id) {
      if (user.role_id === 4) user.role = 'Patient';
      if (user.role_id === 2) user.role = 'Doctor';
    }
    return user;
  } catch {
    return null;
  }
};

const PatientReport = ({ user: propUser }) => {
  // Use propUser if provided, otherwise fallback to localStorage
  const user = propUser || getUserFromLocalStorage();

  // Get patient_id and doctor_id from localStorage
  const patient_id = localStorage.getItem('patient_id');
  const doctor_id = localStorage.getItem('doctor_id');

  const [reports, setReports] = useState([]);
  const [filters, setFilters] = useState({
    test_type: '',
    urgency: '',
    patient_id: '',
    status: '',
  });

  // Normalize role to match backend expectations
  const normalizedUser =
    user && user.role
      ? {
          ...user,
          role:
            user.role.charAt(0).toUpperCase() +
            user.role.slice(1).toLowerCase(),
        }
      : user;
  const isDoctor = normalizedUser?.role === 'Doctor';
  const isPatient = normalizedUser?.role === 'Patient';

  useEffect(() => {
    if (!normalizedUser || !normalizedUser.role) return;
    let url = '';
    let params = {};
    if (normalizedUser.role === 'Patient') {
      url = `${BASE_URL}/api/lab/patient/reports`;
      params = { patient_id: patient_id };
    } else if (normalizedUser.role === 'Doctor') {
      url = `${BASE_URL}/api/lab/doctor/reports`;
      params = {
        doctor_id: doctor_id,
        hospital_id: normalizedUser.hospital_id,
      };
    }
    const token =
      localStorage.getItem('token') || localStorage.getItem('authToken');
    axios
      .get(url, {
        params,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then((res) => setReports(res.data))
      .catch(() => setReports([]));
  }, [normalizedUser, patient_id, doctor_id]);

  // Frontend filtering
  const filteredReports = reports.filter((r) => {
    if (
      filters.test_type &&
      !r.test_type?.toLowerCase().includes(filters.test_type.toLowerCase())
    )
      return false;
    if (
      isDoctor &&
      filters.urgency &&
      !r.urgency?.toLowerCase().includes(filters.urgency.toLowerCase())
    )
      return false;
    if (
      isDoctor &&
      filters.patient_id &&
      !r.receipt_no?.toLowerCase().includes(filters.patient_id.toLowerCase())
    )
      return false;
    if (
      filters.status &&
      !r.status?.toLowerCase().includes(filters.status.toLowerCase())
    )
      return false;
    return true;
  });

  if (!normalizedUser) {
    return (
      <div className="notfound-msg">User not found. Please login again.</div>
    );
  }

  return (
    <div className="container-fluid px-2 px-md-4 py-3">
      <div className="row">
        <Sidebar user={normalizedUser} />
        <div className="p-3">
          <h3 className="global-heading mb-3">Lab Test Reports</h3>
          <Card className="shadow-sm">
            
              <div className="table-responsive">
                <Table
                  striped
                  bordered
                  hover
                  className="lab-reports-table mb-0"
                >
                  <thead>
                    <tr>
                      <th className="text-center">Sr.No.</th>
                      <th className="text-start">
                        Receipt No
                        <input
                          type="text"
                          name="patient_id"
                          className="form-control form-control-sm mt-1"
                          placeholder="Filter by receipt"
                          value={filters.patient_id}
                          onChange={(e) =>
                            setFilters((f) => ({
                              ...f,
                              patient_id: e.target.value,
                            }))
                          }
                        />
                      </th>
                      <th className="text-start">
                        Test Type
                        <input
                          type="text"
                          name="test_type"
                          className="form-control form-control-sm mt-1"
                          placeholder="Filter by test type"
                          value={filters.test_type}
                          onChange={(e) =>
                            setFilters((f) => ({
                              ...f,
                              test_type: e.target.value,
                            }))
                          }
                        />
                      </th>
                      {isDoctor && (
                        <th className="text-start">
                          Urgency
                          <input
                            type="text"
                            name="urgency"
                            className="form-control form-control-sm mt-1"
                            placeholder="Filter by urgency"
                            value={filters.urgency}
                            onChange={(e) =>
                              setFilters((f) => ({
                                ...f,
                                urgency: e.target.value,
                              }))
                            }
                          />
                        </th>
                      )}
                      <th className="text-start">
                        Status
                        <input
                          type="text"
                          name="status"
                          className="form-control form-control-sm mt-1"
                          placeholder="Filter by status"
                          value={filters.status}
                          onChange={(e) =>
                            setFilters((f) => ({
                              ...f,
                              status: e.target.value,
                            }))
                          }
                        />
                      </th>
                      <th className="text-start">Lab</th>
                      {isPatient && <th className="text-start">Doctor</th>}
                      {isDoctor && <th className="text-start">Patient</th>}
                      <th className="text-start d-none d-lg-table-cell">
                        Notes
                      </th>
                      <th className="text-center">Report</th>
                      <th className="d-none d-md-table-cell text-start">
                        Requested At
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredReports.length === 0 && (
                      <tr>
                        <td
                          colSpan={isDoctor ? 10 : 10}
                          className="text-center text-danger"
                        >
                          No reports found.
                        </td>
                      </tr>
                    )}
                    {filteredReports.map((r, index) => (
                      <tr key={r.id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start">{r.receipt_no || '-'}</td>
                        <td className="text-start">{r.test_type}</td>
                        {isDoctor && (
                          <td className="text-start">{r.urgency}</td>
                        )}
                        <td className="text-start">{r.status}</td>
                        <td className="text-start">{r.lab_name || '-'}</td>
                        {isPatient && (
                          <td className="text-start">{r.doctor_name || '-'}</td>
                        )}
                        {isDoctor && (
                          <td className="text-start">
                            {r.patient_name || '-'}
                          </td>
                        )}
                        <td className="text-start d-none d-lg-table-cell">
                          {r.notes || '-'}
                        </td>
                        <td className="text-center">
                          {r.report &&
                          typeof r.report === 'string' &&
                          r.report.trim() !== '' ? (
                            <Button
                              as="a"
                              href={`${BASE_URL}/api/lab/report/${r.report}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-custom"
                              style={{ minWidth: 90 }}
                              download
                              onClick={(e) => {
                                if (
                                  !window.confirm(
                                    'Do you want to download the report?',
                                  )
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            >
                              Download
                            </Button>
                          ) : (
                            'N/A'
                          )}
                        </td>
                        <td className="d-none d-md-table-cell text-start">
                          {r.requested_at
                            ? new Date(r.requested_at).toLocaleString()
                            : '-'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PatientReport;
